import { render, staticRenderFns } from "./importUdf.vue?vue&type=template&id=1572b0b8&scoped=true"
import script from "./importUdf.vue?vue&type=script&lang=js"
export * from "./importUdf.vue?vue&type=script&lang=js"
import style0 from "./importUdf.vue?vue&type=style&index=0&id=1572b0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1572b0b8",
  null
  
)

export default component.exports